import { Core } from "@faire/design-tokens";
import { StrictLocalizeFunction } from "@faire/web/common/localization";

export const ARROW_UP = 38;
export const ARROW_DOWN = 40;
export const RETURN_KEY = 13;
export const TAB_KEY = 9;
export const KEY_EVENT_VALUE = "keydown";
export const MAX_SECTION_RESULT_SIZE = 8;
export const MAX_SPLIT_SECTION_RESULT_SIZE = 5;
export const MAX_SUGGESTION_ITEMS_PER_SECTION = 5;
export const MAX_SUGGESTION_TOP_RESULTS = 6;
export const MAX_DESKTOP_SUGGESTION_ITEM_PER_SECTION = 3;
export const MAX_SEARCH_RECOMMENDATION_PER_SECTION = 7;
export const MAX_SUGGESTION_BRAND_SUGGESTIONS = 5;
export const MAX_DESKTOP_SUGGESTION_BRANDS = 3;
export const MAX_DESKTOP_SUGGESTION_QUERY = 8;
export const MAX_DESKTOP_SUGGESTION_BRANDS_OVERFLOW = 2;
export const MAX_DESKTOP_SUGGESTION_QUERY_OVERFLOW = 2;
export const RESULT_DROPDOWN_SVG_ICON_PROPS = {
  height: "16px",
  width: "16px",
  color: Core.text.default,
  strokeWidth: 1,
};
export const RESULT_DROPDOWN_ITEM_DATA_TEST_ID = "result-dropdown-item-text";

// Sections for default state (user hasn't typed anything)
export const getRecentSearchesHeader = (
  strictLocalize: StrictLocalizeFunction
) => {
  return strictLocalize({
    id: "15hWaQ",
    defaultMessage: "Recent searches",
    description: {
      text: "Search terms used by the retailer recently",
    },
  });
};

export const getRecentlyViewedHeader = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    id: "2yncGv",
    defaultMessage: "Recently viewed",
    description: {
      text: "Brands recently viewed by the retailer",
    },
  });

export const getTrendingSearchesHeader = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    id: "ntRvMQ",
    defaultMessage: "Trending searches",
    description: {
      text: "Search terms currently being used by many customers",
    },
  });

export const getTrendingBrandsHeader = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    id: "4FkiUa",
    defaultMessage: "Trending brands",
    description: {
      text: "Brands being viewed by many customers",
    },
  });

// Sections for activated state (user has started typing)
export const getSuggestedTermsHeader = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    id: "O7ASzQ",
    defaultMessage: "Suggested terms",
    description: {
      text: "Search terms that we think the retailer will find relevant",
    },
  });

export const getNaturalLanguageSearchEmptyStateHeader = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    id: "8pnbiJ",
    defaultMessage: "Try searching with real phrases",
    description: {
      text: "Phrases that the retailer might be interested to search",
    },
  });

export const getBrandsHeader = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({ id: "jWfWEA", defaultMessage: "Brands" });

export const getTopResultsHeader = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    id: "s1Ym9q",
    defaultMessage: "Top results",
    description: {
      text: "The best search results for a given string",
    },
  });

export const getSectionIdMap = (
  strictLocalize: StrictLocalizeFunction
): Record<string, string> => {
  const sectionIdMap: Record<string, string> = {};
  sectionIdMap[getSuggestedTermsHeader(strictLocalize)] = "suggested_terms";
  sectionIdMap[getRecentSearchesHeader(strictLocalize)] = "recent_searches";
  sectionIdMap[getTrendingSearchesHeader(strictLocalize)] = "trending_searches";
  sectionIdMap[getTrendingBrandsHeader(strictLocalize)] = "trending_brands";
  sectionIdMap[getBrandsHeader(strictLocalize)] = "brands";
  sectionIdMap[getRecentlyViewedHeader(strictLocalize)] = "recently_viewed";
  sectionIdMap[getTopResultsHeader(strictLocalize)] = "top_results";
  sectionIdMap[getNaturalLanguageSearchEmptyStateHeader(strictLocalize)] =
    "natural_language_search_empty_state";

  return sectionIdMap;
};
